import { Box, Grid, Tab, Tabs } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { SectionServices } from '../Section/SectionServices';
import Swal from 'sweetalert2';

const SectionTabs = ({selectedSection, setSelectedSection}) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        setSelectedSection(
            sectionList[newValue]
        );
    };

    const [sectionList, setSectionList] = useState([]);
    const fetchSectionList = async () => {
        try{
            const response = await SectionServices.fetchSectionList();
            if(response.success == '1'){
                const sections = response.data.list || [];
                setSectionList(sections);
                setSelectedSection(sections[0] || null);
            }else if(response.success == '0'){
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.message || 'Failed to fetch sections',
                });
                setSectionList([]);
            }

        } catch(error){
            console.log("error", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch section details',
            });
        }
    }
    useEffect(()=>{
        fetchSectionList();
    },[])
  return (
    <Box sx={{ marginTop: '.5%' }}>
        <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            orientation="vertical" // Set the orientation to 'vertical'
            variant="scrollable" // Use 'scrollable' variant for longer lists
            scrollButtons="auto"
            sx={{ backgroundColor: "#fff" }}
            align="left"
        >
            {sectionList?.map((section, index) => (
                <Tab key={index} label={section.title}
                    sx={{
                        borderBottom: '1px solid lightGray',
                        fontSize: '.8rem'
                    }}
                />
            ))}
        </Tabs>
    </Box>
  )
}

export default SectionTabs
